var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24.2233,
    viewBox: "0 0 24 24.2233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10122880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4427 6.46254C17.4427 5.56562 17.7607 4.7913 18.4031 4.14281C19.0423 3.49431 19.8023 3.16845 20.6864 3.16845C21.5704 3.16845 22.3973 3.49431 23.0396 4.14281C23.6788 4.7913 24 5.56562 24 6.46254C24 7.40463 23.6788 8.19831 23.0396 8.85003C22.4004 9.49852 21.615 9.82438 20.6864 9.82438C19.7578 9.82438 19.0391 9.49852 18.4031 8.85003C17.7607 8.20153 17.4427 7.40463 17.4427 6.46254Z",
    fill: "#FF4400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.938 24.2233C5.35523 24.2233 0 18.7902 0 12.1117C0 5.43315 5.35523 0 11.938 0V6.39782C8.83105 6.39782 6.30607 8.96276 6.30607 12.1117C6.30607 15.2606 8.83423 17.8255 11.938 17.8255C15.0417 17.8255 17.5699 15.2638 17.5699 12.1117H23.8759C23.8759 18.7902 18.5207 24.2233 11.938 24.2233Z",
    fill: "#FF4400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsight);
export default __webpack_public_path__ + "static/media/icon-insight.d2c0d1c3f1678800113fb514e4d4cace.svg";
export { ForwardRef as ReactComponent };